import { Button } from '@src/shared/ui/components/Button';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import { FormProvider } from '@uhg-abyss/web/ui/FormProvider';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { SelectInputMulti } from '@uhg-abyss/web/ui/SelectInputMulti';
import { isEmpty, isUndefined } from 'lodash';
import React, { useCallback, useEffect } from 'react';

/**
 * Filters
 *
 * Displays a form to filter the data displayed in the table.
 *
 * @param assets
 * @param queries
 * @param setTheQueries
 * @returns {Element}
 * @constructor
 */
export function Filters({ assets = {}, queries = {}, setTheQueries = () => {} }) {
  const defaultValues = {
    codeCategories: [],
  };

  const form = useForm({ defaultValues });
  const { isSubmitting, isValid } = form.formState;

  /**
   * Mapping data loaded from API to the form state.
   */
  useEffect(() => {
    if (
      !isEmpty(queries) &&
      !isUndefined(assets?.ListCodeCategories?.data?.content?.[0]?.categoryCode) &&
      !isEmpty(assets?.ListCodeCategories?.data?.content?.[0]?.categoryCode)
    ) {
      const selectedCategoryCodes = form?.getValues('codeCategories');

      if (isEmpty(selectedCategoryCodes)) {
        const categoryCode = assets?.ListCodeCategories?.data?.content?.[0]?.categoryCode;

        form?.reset(
          { codeCategories: [categoryCode] },
          {
            keepDirty: false,
            keepDirtyValues: false,
            keepErrors: false,
            keepIsValid: false,
            keepSubmitCount: true,
            keepTouched: false,
            keepValues: false,
          }
        );
      }
    }
  }, [assets, queries]);

  /**
   * handleSubmit
   *
   * Retrieves the filtered data from the remote API.
   *
   * @returns {Promise<void>}
   */
  const handleSubmit = useCallback(
    (submittedValues) => {
      if (!isSubmitting && isValid) {
        const theQueries = [];

        submittedValues?.codeCategories?.forEach((categoryCode) => {
          theQueries.push({
            apiKey: 'Code',
            payload: {
              categoryCode,
              page: 0,
              size: 9999,
              sort: 'codeId,asc',
            },
            queryKey: `ListCodes-${categoryCode}`,
          });
        });

        setTheQueries(theQueries);
      }
    },
    [isSubmitting, isValid]
  );

  return (
    <ErrorHandler location="src/entities/Code/ui/components/tables/Codes/components/Filters/Filters.jsx">
      <FormProvider autoComplete="off" highlighted onSubmit={handleSubmit} state={form}>
        <Layout.Group alignItems="bottom" alignLayout="left">
          <SelectInputMulti
            isSearchable
            label="Category Code"
            maxListHeight="350px"
            model="codeCategories"
            options={
              assets?.ListCodeCategories?.data?.content?.map((item) => {
                return {
                  label: item?.categoryCode,
                  value: item?.categoryCode,
                };
              }) || []
            }
            placeholder="Select Category Code(s)"
            selectAll
            width="300px"
          />

          <Button type="submit" variant="solid">
            Apply
          </Button>
        </Layout.Group>
      </FormProvider>
    </ErrorHandler>
  );
}
